// AppHeaderView moved into Views/App/HeaderView.tsx. This thin re-export barrel keeps the
// original `./AppHeaderView` import path working for the demo app (LogbookContentView)
// that imports AppHeaderView outside the AppView hub.

export { AppHeaderView } from "./App/HeaderView"
